import GithubNativeConnected from '../../../containers/source-integration/independent-integrations/github-native'

export const githubNative = {
  component: GithubNativeConnected,
  data: {
    title: 'Spectral Github Native Scanner',
    tileKey: 'github-native',
  },
}
